<template>
  <li class="cart-widget" :data-overlay-toggle="!hasCart" @click="onCartClick">
    <template v-if="hasCart">
      <div class="cart-widget__cart">
        <SVGCart/>
        <template v-if="cartAmount">
          <span class="cart-widget__count">{{cartAmount}}</span>
        </template>
        <span class="cart-widget__text">{{cartPriceDisplay}}</span>
      </div>
    </template>
    <template v-else>
      <SVGCart/>
      <a href="https://shop.loasia.ch/">
        <span class="cart-widget__text">
          {{$t('minicart.orderText') }}
        </span>
      </a>

    </template>
  </li>
</template>

<script>
  import {mapGetters} from "vuex"
  import { trackEvent } from '@/helpers/gtm'

  export default {
    computed: {
      ...mapGetters('cart', [
        'hasCart',
        'cartAmount',
        'cartPriceDisplay'
      ])
    },
    methods: {
      onCartClick() {

        if (this.hasCart) {
          trackEvent('Mini-Cart', 'Klick')
          this.$store.dispatch('redirectToExistingCart')
        } else {
          trackEvent('Header-Orderbutton', 'Klick')
        }
      }
    }
  }
</script>

<style>

</style>
